import { option } from '@code-expert/prelude';
import { GuardOption } from '@code-expert/react';
import { styled } from '/imports/ui/foundation/Theme';

export interface AvatarProps {
  user: option.Option<{ firstname: string; lastname: string }>;
  state?: 'default' | 'hover' | 'active';
}

export const Avatar = ({ user, state = 'default', ...props }: AvatarProps) => (
  <Container {...props} fallback={option.isNone(user)} className={`is-${state}`}>
    <GuardOption
      value={user}
      alt={() => <FallbackUserIcon />}
      render={({ firstname, lastname }) => (
        <>
          {firstname.substring(0, 1)}
          {lastname.substring(0, 1)}
        </>
      )}
    />
  </Container>
);

// -------------------------------------------------------------------------------------------------

const Container = styled('button', ({ tokens }) => ({
  display: 'grid',
  placeContent: 'center',
  width: 44,
  aspectRatio: '1 / 1',
  overflow: 'hidden',
  border: `2px solid ${tokens.colorBorder}`,
  borderRadius: '50%',
  fontSize: tokens.fontSizeXL,
  color: tokens.colorIcon,
  cursor: 'pointer',
  background: 'transparent',

  '&.is-hover, &:hover': {
    background: tokens.colorBgTextHover,
    color: tokens.colorIconHover,
  },

  '&.is-active, &:active': {
    background: tokens.colorBgTextActive,
    color: tokens.colorIconHover,
  },

  variants: {
    fallback: {
      true: {
        placeContent: 'stretch',
        padding: 0,
      },
    },
  },
}));

const FallbackUserIcon = styled('div', ({ tokens }) => ({
  position: 'relative',
  clipPath: 'circle(46%)',
  // Head
  '&::before': {
    content: '""',
    position: 'absolute',
    transform: 'translate(-50%, 65%)',
    width: 14,
    aspectRatio: '1 / 1',
    background: tokens.colorBorder,
    borderRadius: '50%',
  },
  // Body
  '&::after': {
    content: '""',
    position: 'absolute',
    transform: 'translate(-50%, 54%)',
    width: 40,
    height: 50,
    background: tokens.colorBorder,
    borderRadius: '42%',
  },
}));
